import { rem, themed } from '@heathmont/moon-utils';
import styled from 'styled-components';
import getTextSize from '../private/text/getTextSize';
const Heading = styled.h3(({ color = 'bulma.100', theme }) => ({
    color: themed('color', color)(theme),
}), ({ size = 16 }) => getTextSize(size), ({ textAlign }) => textAlign && { textAlign }, ({ isRegular, theme }) => ({
    fontWeight: isRegular
        ? theme.newTokens.font.weight.normal
        : theme.newTokens.font.weight.semibold,
}), ({ isUppercase }) => isUppercase && {
    textTransform: 'uppercase',
}, ({ isUnderline }) => isUnderline && {
    textDecoration: 'underline',
}, ({ lineHeight }) => lineHeight && {
    lineHeight: rem(lineHeight),
});
export default Heading;
